import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  ElementRef,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardingHRDetail } from "../../shared/models/OnboardingHRDetail";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSortHeader, MatSort, MatDialog, Sort } from "@angular/material";
import { Router } from "@angular/router";
//import * as jspdf from 'jspdf';
//import html2canvas from 'html2canvas';
import { ToastrService } from "ngx-toastr";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { UserService } from "../../shared/service/user.service";
//import { DownloadDialog, DownloadDialogComponent } from '../../shared/download-dialog/download-dialog.component';

@Component({
  selector: "app-employee-list",
  templateUrl: "./employee-list.component.html",
  styleUrls: ["./employee-list.component.css"],
})
export class EmployeeListComponent implements OnInit {
  exampl: any;
  result: any;
  empList: OnboardingHRDetail[];
  error: string;
  dataSourceFTE: MatTableDataSource<OnboardingHRDetail>;
  originalDataSourceAll: any;
  locationsList: any[];
  permission: any;
  editEnable: boolean = false;
  deleteEnable: boolean = false;
  lstData: any;
  constructor(
    private _service: OnboardingService,
    public router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private _userService: UserService
  ) {
    this.empList = [];
    this.dataSourceFTE = new MatTableDataSource();
  }
  displayedColumns: string[] = [
    "FirstName",
    "LocationName",
    "DOJ",
    "EmpEmailId",
    "EmployeeStatus",
    "Status",
    "Edit",
    "Delete",
  ];
  @ViewChild(MatPaginator, { static: false }) paginatorFTE: MatPaginator;
  @ViewChild(MatSort, { static: false }) sortFTE: MatSort;
  @ViewChild("input", { static: false }) input: ElementRef;
  check: boolean = false;
  isLoader: boolean = true;

  ngOnInit() {
    this.getLocations();
    this.getEmployeeDetails();
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Menu === "Onboarding"
    );
    if (this.permission.HasFullAccess || this.permission.EditingPermission)
      this.editEnable = true;
    if (this.permission.HasFullAccess || this.permission.DeletingPermission) {
      this.deleteEnable = true;
    }
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }

  sortData(sort: Sort): void {
    this.lstData = this.dataSourceFTE.data;
    let data = this.lstData.slice();
    if (!sort.active || sort.direction == '') {
      this.dataSourceFTE = new MatTableDataSource(data);
      return;
    }

    this.dataSourceFTE = new MatTableDataSource(
      data.sort((a, b) => {
        let isdesc = sort.direction == "desc";
        switch (sort.active) {
          case "FirstName":
            return compare(a.FirstName.toLowerCase(), b.FirstName.toLowerCase(), isdesc);
          case "LocationName":
            return compare(a.LocationName, b.LocationName, isdesc);
          case "DOJ":
            return compare(a.DOJ, b.DOJ, isdesc);
          case "EmpEmailId":
            return compare(a.EmpEmailId.toLowerCase(), b.EmpEmailId.toLowerCase(), isdesc);
          case "EmployeeStatus":
            return compare(a.Type, b.Type, isdesc);
          case "Status":
            return compare(a.Status, b.Status, isdesc);
          default:
            return 0;
        }
      })
    );
  }

  applyFilter(filterValue: string) {
    if (filterValue != "" && filterValue != null) {
      this.dataSourceFTE = new MatTableDataSource(
        this.originalDataSourceAll.filter(
          (res) =>
            (res.FirstName != "" &&
              res.FirstName != null &&
              this.removeExtraSpaces(res.FirstName.toLowerCase()).startsWith(
                this.removeExtraSpaces(filterValue.toLowerCase())
              ))
        )
      );
    } else {
      this.dataSourceFTE = new MatTableDataSource(this.originalDataSourceAll);
    }
    this.dataSourceFTE.paginator = this.paginatorFTE;
    this.dataSourceFTE.sort = this.sortFTE;
    this.lstData = this.dataSourceFTE.data;
  }

  getLocations() {
    this._service.getLocations().subscribe((data: any) => {
      this.locationsList = data;
    });
  }
  getEmployeeDetails() {
    this.empList = [];
    this.dataSourceFTE = new MatTableDataSource();
    this._service.getEmpList().subscribe(
      (data: OnboardingHRDetail[]) => {
        data.forEach((element) => {
          // Status 3 indicates that employee is verified
          if (element.Status != 3 && element.IsDeleted != 1) {
            if (element.LastName != null) {
              element.FirstName = element.FirstName.concat(
                " " + element.LastName
              );
            }
            if (this.locationsList != null) {
              for (var i = 0; i < this.locationsList.length; i++) {
                //match the location id and get location name
                if (element.LocationID == this.locationsList[i].ID) {
                  element.LocationName = this.locationsList[i].LocationName;
                }
              }
            }
            this.empList.push(element);
          }
        });

        this.dataSourceFTE.data = this.empList;
        this.originalDataSourceAll = this.empList;
        this.dataSourceFTE.paginator = this.paginatorFTE;
        this.dataSourceFTE.sort = this.sortFTE;
        this.lstData = this.dataSourceFTE.data;
      },
      (error) => (this.error = error)
    );
  }
  navigate(element) {
    this.router.navigateByUrl("/EmployeeVerification" + "/" + element.Slug);
  }
  editEmployee(val) {
    this.router.navigateByUrl("/onboardingdetails" + "/" + val);
  }
  deleteEmployee(val) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(
      " ",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this._service.DeleteOnboardingEmployee(val).subscribe(
            (data) => {
              this.toastr.success("Deleted successfully");
              this.getEmployeeDetails();
            },
            (error) => (this.error = error)
          );
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }
}

function compare(a, b, isdesc) {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }

  if (a === b) return 0;

  if (isdesc) return a < b ? 1 : -1;
  else return a < b ? -1 : 1;
}
